import React, { useState } from 'react'
import {
  Edit,
  required,
  SimpleForm,
  TextInput,
  useNotify,
  useRedirect,
  useTranslate,
  useRecordContext,
} from 'react-admin'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { ColorPIckerInput } from 'src/components/uiElements/fields/ColorPIckerInput'
import { AutocompleteInput } from 'src/components/uiElements/fields/AutocompleteInput'

const RecordAutocompleteInput = ({ getWorkUnit, workUnitList, loadingWorkUnitList }) => {
  const tag = useRecordContext()
  const translate = useTranslate()
  return (
    <EditInputsWrap
      label={translate('ra.field.work_unit')}
      required
      tooltiptext={translate('ra.message.valid_characters', { num: 3 })}
    >
      <AutocompleteInput
        source='work_unit_id'
        options={workUnitList}
        loading={loadingWorkUnitList}
        optionValue='id'
        optionsText={['long_name']}
        onSearch={getWorkUnit}
        validate={[required()]}
        useOptionValue={true}
        positionOptionsText={0}
        defaultValue={tag?.work_unit ? { ...tag?.work_unit, work_unit_id: tag?.work_unit?.id } : null}
      />
    </EditInputsWrap>
  )
}

export const TagEdit = (props, { id }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [workUnitList, setWorkUnitList] = useState([])
  const [loadingWorkUnitList, setLoadingWorkUnitList] = useState(false)

  const getWorkUnit = async (long_name, minLength = 3) => {
    if (long_name?.length < minLength) {
      setWorkUnitList([])
      return
    }

    try {
      setLoadingWorkUnitList(true)
      const allWorkUnit = await workUnitServices.getByAll({ long_name: long_name })
      setWorkUnitList(allWorkUnit)
      setLoadingWorkUnitList(false)
    } catch (error) {
      setWorkUnitList([])
      setLoadingWorkUnitList(false)
    }
  }

  const onSuccess = () => {
    notify('ra.notification.updated_success_femenine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.tag') },
    })
    redirect('/tag')
  }

  const onError = () => {
    notify('ra.notification.updated_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.tag') },
    })
  }

  const transform = (data) => {
    return {
      ...data,
      work_unit_id: data?.work_unit?.id
    }
  }

  return (
    <Edit
      {...props}
      mutationMode='pessimistic'
      mutationOptions={{ onSuccess, onError }}
      actions={null}
      transform={transform}
    >
      <CardCommon title={translate('ra.title.update_tag')}>
        <SimpleForm
          toolbar={
            <CardCrudBottomButtons
              btnSave={true}
              btnDelete={true}
              fieldsName={['short_name']}
              genderElement='femenine'
            />
          }
        >
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.id')}>
              <TextInput disabled source='id' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.short_name')}>
              <TextInput source='short_name' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.long_name')} required>
              <TextInput source='long_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <RecordAutocompleteInput
              loadingWorkUnitList={loadingWorkUnitList}
              getWorkUnit={getWorkUnit}
              workUnitList={workUnitList}
            />
            <EditInputsWrap label={translate('ra.field.symbol')}>
              <TextInput source='symbol' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.color')}>
              <ColorPIckerInput source='color' fullWidth validate={[required()]} />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
